module.exports = __webpack_public_path__ + "static/media/all.2964ed0a.pred";